import { create } from "zustand";
import { persist } from "zustand/middleware";
import {
  getCart,
  updateCart,
  removeFromCart,
  addToCart,
} from "../services/cartService";

export const useCartStore = create(
  persist(
    (set, get) => ({
      cartProducts: [],
      initializeCart: () => {
        const cart = getCart()?.value;
        set({ cartProducts: Array.isArray(cart) ? cart : [] });
      },

      handleAddToCart: (product) => {
        const result = addToCart(product);
        set({ cartProducts: Array.isArray(result?.value) ? result.value : [] });
      },

      handleUpdateCart: (updatedProduct) => {
        const result = updateCart(updatedProduct);
        set({ cartProducts: Array.isArray(result?.value) ? result.value : [] });
      },

      handleRemoveFromCart: ({ productID, variantID }) => {
        const result = removeFromCart({ productID, variantID });
        set({ cartProducts: Array.isArray(result?.value) ? result.value : [] });
      },

      clearCart: () => {
        // 1. Wipe out your manual storage reference
        localStorage.removeItem("cartProducts");

        // 2. Clear out Zustand's memory to automatically update 'cart-storage'
        set({ cartProducts: [] });
      },

      // Helper for checkout validation (Instant access, no delay)
      getLatestCart: () => get().cartProducts,
    }),
    { name: "cart-storage" },
  ),
);
